/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { notification, Select } from 'antd';
import { api } from '@seaoil/component-lib';

const { Option } = Select;
const { mySEAOIL } = api;

function ModeOfPaymentField({
  // attributes
  placeholder,
  disabled,

  // methods
  onInputSelect,
}) {
  const [modeOfPayments, setModeOfPayments] = useState([]);
  const [loading, isLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const retryLimit = 5;
  let retryCount = 0;

  const loadModeOfPayments = async () => {
    isLoading(() => true);
    try {
      const segs = await mySEAOIL.datawarehouse.getModeOfPayments().send();
      setModeOfPayments(segs);
    } catch (e) {
      if (retryCount > retryLimit) {
        notification.error({ message: 'Unable to load mode of payments after multiple retries. Kindly contact supportdesk@seaoil.com.ph' });
      } else {
        notification.error({ message: 'Unable to load mode of payments. Retrying after 2 seconds...' });
        setTimeout(loadModeOfPayments, 2000);
        retryCount += 1;
      }
    } finally {
      isLoading(() => false);
    }
  };

  useEffect(() => {
    loadModeOfPayments();
  }, []);

  useEffect(() => {
    if (!Array.isArray(modeOfPayments)) {
      return;
    }

    setOptions(modeOfPayments.map(({
      mode_of_payment,
    }) => ({
      value: mode_of_payment,
      label: mode_of_payment,
    })));
  }, [modeOfPayments]);

  return (
    <Select
      placeholder={loading ? 'Loading...' : placeholder}
      disabled={loading || disabled}
      onChange={onInputSelect}
    >
      {options.map((option, index) => (
        <Option
          key={index}
          value={option.value}
        >
          {option.label}
        </Option>
      ))}
    </Select>
  );
}

export default ModeOfPaymentField;
